import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Content from './Content';
import '../styles/sidenav.scss'
import { AiOutlineBell } from "react-icons/ai";

import styled from 'styled-components';


function Sidenav() {

  const TotalProductss = styled(AiOutlineBell)`
 
  color: #F9FFFF; 
`;
  return (
    <>
      <div class="container-fluid" style={{ background: '#101415' }}>
        <div class="row flex-nowrap">
          <div class="col-auto col-md-3 col-xl-2 px-sm-2 px-0 bg-dark  sidebar" style={{ width: '200px' }}>
            <div class="d-flex flex-column align-items-center align-items-sm-start px-3 pt-2 text-white min-vh-100"
           style={{ postion: 'fixed' }} >
              <a
                href="/"
                class="d-flex align-items-center pb-3 mb-md-0 me-md-auto text-white text-decoration-none"
              >
                <span class="fs-5 d-none d-sm-inline">Menu</span>
              </a>
              <ul
                class="nav nav-pills flex-column mb-sm-auto mb-0 align-items-center align-items-sm-start"
                id="menu"
              >
                <li class="nav-item">
                  <a href="#" class="nav-link align-middle px-0">
                    <i class="fs-4 bi-house"></i>{" "}
                    <span class="ms-1 d-none d-sm-inline">Home</span>
                  </a>
                </li>
                <li>
                  <a
                    href="#submenu1"
                    data-bs-toggle="collapse"
                    class="nav-link px-0 align-middle"
                  >
                    <i class="fs-4 bi-speedometer2"></i>{" "}
                    <span class="ms-1 d-none d-sm-inline">Dashboard</span>{" "}
                  </a>
                  <ul
                    class="collapse show nav flex-column ms-1"
                    id="submenu1"
                    data-bs-parent="#menu"
                  >
                    <li class="w-100">
                      <a href="#" class="nav-link px-0">
                        {" "}
                        <span class="d-none d-sm-inline">Item</span> 1{" "}
                      </a>
                    </li>
                    <li>
                      <a href="#" class="nav-link px-0">
                        {" "}
                        <span class="d-none d-sm-inline">Item</span> 2{" "}
                      </a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a href="#" class="nav-link px-0 align-middle">
                    <i class="fs-4 bi-table"></i>{" "}
                    <span class="ms-1 d-none d-sm-inline">Orders</span>
                  </a>
                </li>
                <li>
                  <a
                    href="#submenu2"
                    data-bs-toggle="collapse"
                    class="nav-link px-0 align-middle "
                  >
                    <i class="fs-4 bi-bootstrap"></i>{" "}
                    <span class="ms-1 d-none d-sm-inline">Bootstrap</span>
                  </a>
                  <ul
                    class="collapse nav flex-column ms-1"
                    id="submenu2"
                    data-bs-parent="#menu"
                  >
                    <li class="w-100">
                      <a href="#" class="nav-link px-0">
                        {" "}
                        <span class="d-none d-sm-inline">Item</span> 1
                      </a>
                    </li>
                    <li>
                      <a href="#" class="nav-link px-0">
                        {" "}
                        <span class="d-none d-sm-inline">Item</span> 2
                      </a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a
                    href="#submenu3"
                    data-bs-toggle="collapse"
                    class="nav-link px-0 align-middle"
                  >
                    <i class="fs-4 bi-grid"></i>{" "}
                    <span class="ms-1 d-none d-sm-inline">Products</span>{" "}
                  </a>
                  <ul
                    class="collapse nav flex-column ms-1"
                    id="submenu3"
                    data-bs-parent="#menu"
                  >
                    <li class="w-100">
                      <a href="#" class="nav-link px-0">
                        {" "}
                        <span class="d-none d-sm-inline">Product</span> 1
                      </a>
                    </li>
                    <li>
                      <a href="#" class="nav-link px-0">
                        {" "}
                        <span class="d-none d-sm-inline">Product</span> 2
                      </a>
                    </li>
                    <li>
                      <a href="#" class="nav-link px-0">
                        {" "}
                        <span class="d-none d-sm-inline">Product</span> 3
                      </a>
                    </li>
                    <li>
                      <a href="#" class="nav-link px-0">
                        {" "}
                        <span class="d-none d-sm-inline">Product</span> 4
                      </a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a href="#" class="nav-link px-0 align-middle">
                    <i class="fs-4 bi-people"></i>{" "}
                    <span class="ms-1 d-none d-sm-inline">Customers</span>{" "}
                  </a>
                </li>
              </ul>
              <hr />
              <div class="dropdown pb-4">
                <a
                  href="#"
                  class="d-flex align-items-center text-white text-decoration-none dropdown-toggle"
                  id="dropdownUser1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <img
                    src="https://github.com/mdo.png"
                    alt="hugenerd"
                    width="30"
                    height="30"
                    class="rounded-circle"
                  />
                  <span class="d-none d-sm-inline mx-1">loser</span>
                </a>
                <ul class="dropdown-menu dropdown-menu-dark text-small shadow">
                  <li>
                    <a class="dropdown-item" href="#">
                      New project...
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" href="#">
                      Settings
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" href="#">
                      Profile
                    </a>
                  </li>
                  <li>
                    <hr class="dropdown-divider" />
                  </li>
                  <li>
                    <a class="dropdown-item" href="#">
                      Sign out
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col " maincontent style={{ width: 'calc(100% - 200px)' }} >
            <Navbar  expand="lg">
              <Container fluid>
                <Navbar.Brand href="#" style={{ color: '#FAFEFF' }}>Dashboard</Navbar.Brand>
                <Navbar.Toggle aria-controls="navbarScroll" />
                <Navbar.Collapse id="navbarScroll">
                  <Nav
                    className="me-auto my-2 my-lg-0"
                    style={{ maxHeight: "100px" }}
                    navbarScroll
                  ></Nav>
                  <Form className="d-flex">
                    <Form.Control
                      type="search"
                      placeholder="Search"
                      className="me-2"
                      aria-label="Search"
                      style={{
                        backgroundColor: '#191C25',
                        borderColor: '#7C7F88',
                        borderWidth: 1,
                        borderStyle: 'solid',
                        color: 'black',
                        borderRadius: 5,
                      }}
                    />
                    
                   
                  </Form>
                  <TotalProductss style={{ fontSize: '30px',paddingRight:'6px',paddingLeft: '6px', marginRight:'10px',borderRadius: '5px',fontColor:'#9699A0'}}/> 
                </Navbar.Collapse>
              </Container>
            </Navbar>
            <div className="container-fluid">
               <Content/>
            </div>
            
          </div>
          
        </div>
        
      </div>
    </>
  );
}

export default Sidenav;
